import React from "react";
import { Box, Typography } from "@mui/material";
import IconCircle from "../../shared/IconCircle";
import { cardDescSx, cardTitleSx, COLORS, CONTENT_MAX_WIDTH } from "../../shared/styles";
import { RoutingEnvelopeIcon } from "./icons";

function TicketRoutingInfoCard() {
  return (
    <Box
      sx={{
        mt: "40px",
        width: "100%",
        maxWidth: CONTENT_MAX_WIDTH,
        minHeight: "136px",
        p: "16px",
        borderRadius: "8px",
        border: `1px solid ${COLORS.primary}`,
        bgcolor: "#F3FBFF",
        boxShadow: "0 1px 2px 0 rgba(20, 141, 253, 0.10)",
        boxSizing: "border-box",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "flex-start", gap: "16px" }}>
        <IconCircle bgcolor="#D6EDFF">
          <RoutingEnvelopeIcon />
        </IconCircle>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography component="p" sx={cardTitleSx}>
            How Ticket Routing Works
          </Typography>
          <Typography
            component="p"
            sx={{
              ...cardDescSx,
              mt: "4px",
              lineHeight: "24px",
            }}
          >
            Configure automatic assignment rules for new tickets. Choose between no auto-assignment,
            round-robin to all available agents in the group, or round-robin to a specific team
            within the group.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default TicketRoutingInfoCard;
